import { ReactNode, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { addDiscountToCart, clearCart } from '@/lib/carts';
import { loadCart } from '@/lib/carts';

const BaseLayout = dynamic(() => import('./BaseLayout'), {
  ssr: true,
});

const PrivateAreaLayout = dynamic(() => import('./PrivateAreaLayout'), {
  ssr: true,
});
import { TypeLayouts } from './types';
import { Meta, MetaProp } from "./meta";
import { fetchUniLimitId } from '@/lib/unitLimitId';
import { AppDispatch } from '@/lib/store';

/**
 * Layout
 */
const Layout = ({
  layoutType,
  children,
  meta,
  canonical,
  ...props
}: {
  theme: string;
  preFooter?: boolean;
  children: ReactNode | ReactNode[];
  layoutType: TypeLayouts;
  title?: string;
  className?: string;
  meta?: MetaProp[],
  canonical: string,
  blocks
}): JSX.Element => {
  const dispatch = useDispatch<AppDispatch>();
  const router = useRouter();
  const { query, isReady } = router;

  useEffect(() => {
    if (query.checkout === 'ok') {
      dispatch(clearCart());
    }
  }, [query.checkout])

  useEffect(() => {
    if (isReady && query.new_cart === undefined) {
      dispatch(loadCart()).then(() => {

        const discountParam = router.query.discount;
        const discount = Array.isArray(discountParam)
          ? discountParam[0]
          : discountParam;
        if (!discount) return;

        const applyDiscount = async () => {
          await dispatch(addDiscountToCart({ discount }));
          const slug = router.query.slug;
          const path = slug != undefined ?
            Array.isArray(slug)
              ? `/${slug.join("/")}`
              : `/${slug}`
            :
            router.pathname;
          router.replace(
            { pathname: path },
            undefined,
            { shallow: true }
          );
        };

        applyDiscount();
      });
      dispatch(fetchUniLimitId());
    }
  }, [dispatch, isReady]);

  useEffect(() => {
    const handler = (event: StorageEvent) => {
      if (
        event.storageArea === window.localStorage &&
        (event.key === 'cart' && event.oldValue !== event.newValue) || (event.key === 'cart-version' && event.oldValue < event.newValue)
      ) {
        dispatch(loadCart());
      }
    };

    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const SelectedLayout = useMemo(() => {
    switch (props.title == '404' ? '404' : layoutType) {
      case 'account':
        return PrivateAreaLayout;
      default:
        return BaseLayout;
    }
  }, [layoutType, props.title]);
  return <SelectedLayout {...props}><Meta meta={meta} canonical={canonical} />{children}</SelectedLayout>;
};
export default Layout;
